import { render, staticRenderFns } from "./BusinessInfoForm.vue?vue&type=template&id=b16f9ce8&scoped=true"
import script from "./BusinessInfoForm.vue?vue&type=script&lang=js"
export * from "./BusinessInfoForm.vue?vue&type=script&lang=js"
import style0 from "./BusinessInfoForm.vue?vue&type=style&index=0&id=b16f9ce8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b16f9ce8",
  null
  
)

export default component.exports